export enum PositionGroupingEnum {
  PRODUCT_TYPE = 'PRODUCT_TYPE',
  USER_DEFINED = 'USER_DEFINED',
}

